import { post, get, put, del } from 'aws-amplify/api';

// Helper function to check if API is properly configured
const checkApiConfig = () => {
  return true;
};

const transformResponse = async (response) => {
    const { statusCode, body } = (await response);
    const result = await body.json();
    if (statusCode !== 200 || result?.errorMessage || result?.errorType || result?.error) {
        throw new Error(result?.errorMessage || result?.errorType || result?.error);
    }
    return {
        statusCode, result: result.result,
    }
}

// Helper function to handle API responses
const handleApiResponse = (response) => {
  
  if (response && response.data) {
    return response.data;
  }
  
  return response;
};

const apiName = 'identx';

// const Identx_API = {
//     get: (path, init = {}) => get({ apiName, path, options: init }),
//     put: (path, body = {}, headers = {}) => put('identx', path, { body, headers }),
//     post: (path, body = {}, headers = {}) =>  post('identx', path, { body, headers }),
//     del: (path, init) => del('identx', path, init),
//   };


// Generic API methods using Amplify API v6 REST
export const apiService = {
  // GET request
  get: async (endpoint) => {
    if (!checkApiConfig()) {
      throw new Error('API not configured');
    }
    try {
      const { response } = get({ apiName, path: endpoint });
      const { result } = await transformResponse(response);
      
      return handleApiResponse(result);
    } catch (error) {
      console.error(`Error in GET ${endpoint}:`, error);
      throw error;
    }
  },
  
  // POST request
  post: async (endpoint, data, headers={}) => {
    if (!checkApiConfig()) {
      throw new Error('API not configured');
    }
    try {
      const { response } = await post({ apiName, path: endpoint, options: { body: data, headers }});
      const { result } = await transformResponse(response);
      
      return handleApiResponse(result);
    } catch (error) {
      console.error(`Error in POST ${endpoint}:`, error);
      throw error;
    }
  },
  
  // PUT request
  put: async (endpoint, data, headers={}) => {
    if (!checkApiConfig()) {
      throw new Error('API not configured');
    }
    try {
      const { response } = await put({ apiName, path: endpoint, options: { body: data, headers }});
      const { result } = await transformResponse(response);
      
      return handleApiResponse(result);
    } catch (error) {
      console.error(`Error in PUT ${endpoint}:`, error);
      throw error;
    }
  },
  
  // DELETE request
  delete: async (endpoint, data = {}, headers={}) => {
    if (!checkApiConfig()) {
      throw new Error('API not configured');
    }
    try {
      const { response } = await del({ apiName, path: endpoint, options: { body: data, headers }});
      const { result } = await transformResponse(response);
      
      return handleApiResponse(result);
    } catch (error) {
      console.error(`Error in DELETE ${endpoint}:`, error);
      throw error;
    }
  },
};

export default apiService;
